import React, { useState } from "react";
import useStyles from "./styles";
import LoginSignUpModal from "../../../Login/loginSignUpModal";
import Box from "@material-ui/core/Box";
import Typography  from "@material-ui/core/Typography";
import DefaultLogo from "../../../../../assets/images/defaultLogo.png";
import { thumborImageUrl } from "../../../../../Utility";
import MobileNavDrawer from "../11/mobile-navbar";
import MenuIcon from "@material-ui/icons/Menu";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Menu from "@material-ui/core/Menu";
import Button  from "@material-ui/core/Button";
import useMemeberInfo from "../../../../../dataHook/useMemeberInfoHook";
import useNavbarInfo from "../../../../../dataHook/useNavHook";
import useDeviceView from "../../../../../dataHook/useDeviceView";
const Component12 = ({ websiteData, widgetList }) => {
  const classes = useStyles();
  const {deskTopView = false} = useDeviceView()
  const [showLogin, setShowLogin] = useState(false);
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const [showKnowMore, setShowKnowMore] = useState(null);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);

 const {username = null,isLoggedIn,user={}} = useMemeberInfo();
  const {logo_url,contentArr  = [],handleLogout=()=>{},phone_numbers=[],emails = []} = useNavbarInfo();
  if(contentArr?.length <= 0) return null;
  const [phoneNumber] = phone_numbers.filter(
    (item) => item.is_deleted === false && item.is_active === true
  );

  const [email] = emails.filter(
    (item) => item.is_deleted === false && item.is_active === true
  );

  let [loginObj] = contentArr.filter((obj) => obj.name == "Login");
  let updatedContentArr = contentArr.filter((obj) => obj.name != "Login");


  const DropDownType = ({ isBtn = false, items = [] }) => {
    let { name = "", link = "", id = "" } = items;
    if (id == "logout") {
      return <MenuItem onClick={handleLogout}>{name}</MenuItem>;
    } else if (link) {
      return (
        <MenuItem
          style={{
            textTransform: "capitalize",
          }}
          component={"a"}
          href={link}
        >
          {name}
        </MenuItem>
      );
    } else {
      return <MenuItem>{name}</MenuItem>;
    }
  };

  let { dropDownItem: loginDropDown = [] } = loginObj;

  const handleClick = (event) => {
    setShowKnowMore(event.currentTarget);
  };

  const handleClose = () => {
    setShowKnowMore(null);
  };

  const handleClickLogin = (event) => {
    setShowLoginDropDown(event.currentTarget);
  };

  const handleCloseLogin = () => {
    setShowLoginDropDown(null);
  };

  return (
    <>
      <div className={classes.header}>
        <div className={classes.footerHead}>
          <div className={classes.contactContainer}>
            {phoneNumber && (
              <span>
                <PhoneIcon
                  style={{ fontSize: "1rem", marginRight: "0.3rem" }}
                />
                {`Phone: ${phoneNumber.phone_no}`}
              </span>
            )}
            {email && (
              <span>
                <EmailIcon
                  style={{ fontSize: "1rem", marginRight: "0.3rem" }}
                />
                {`Mail: ${email.email}`}
              </span>
            )}
          </div>

          <Box style={{ display: "flex", alignItems: "center" }}>
            <img
              className={classes.logoImg}
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              onClick={() => {
                window.location.href = `/${username ? `${username}` : ""}`;
              }}
            />
          </Box>
          <div className={classes.loginContainer}>
            {isLoggedIn ? (
              <>
                <Box
                  style={{ cursor: "pointer" }}
                  display={"flex"}
                  onClick={handleClickLogin}
                >
                  <Typography> {`Hi ${user?.username || ''}`}</Typography>
                  <Box display={"flex"} alignItems={"center"}>
                    <ExpandMoreIcon color="primary.contrastText" />
                  </Box>
                </Box>
                <Menu
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: "bottom",
                  }}
                  transformOrigin={{
                    vertical: "top",
                  }}
                  anchorEl={showLoginDropDown}
                  keepMounted
                  open={Boolean(showLoginDropDown)}
                  onClose={handleCloseLogin}
                  className={classes.dropdownContainerLogin}
                >
                  {loginDropDown.map((items) => {
                    let { isBtn = false } = items;
                    return <DropDownType items={items} isBtn={isBtn} />;
                  })}
                </Menu>
              </>
            ) : (
              <Button
                className={classes.loginButton}
                onClick={() => setShowLogin(true)}
              >
                Login
              </Button>
            )}
          </div>
        </div>
        <div className={classes.footerTail}>
          <Box
            display="flex"
            alignItems="center"
            style={{
              padding: "20px 14px",
            }}
            className={classes.menu}
          >
            <MenuIcon
              className={classes.menuIcon}
              onClick={() => setShowMenuDrawer(true)}
            />
            <MobileNavDrawer
              widgetList={widgetList}
              websiteData={websiteData}
              showDrawer={showMenuDrawer}
              setShowDrawer={setShowMenuDrawer}
              contentArr={contentArr}
            />
          </Box>

          <Box display="flex" className={classes.navbar}>
            {updatedContentArr.map((item) => {
              let { isDropdown = false, dropDownItem = [] } = item;
              return isDropdown ? (
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    display={"flex"}
                    alignItems={"center"}
                  >
                    <a
                      href={item.link}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                      }}
                      className={classes.navItem}
                    >
                      {item.name}
                      <ExpandMoreIcon
                        style={{
                          color: "inherit",
                        }}
                      />
                    </a>
                  </Box>
                  <Menu
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                    }}
                    transformOrigin={{
                      vertical: "top",
                    }}
                    anchorEl={showKnowMore}
                    keepMounted
                    open={Boolean(showKnowMore)}
                    onClose={handleClose}
                  >
                    {dropDownItem.map((items) => {
                      let { isBtn = false } = items;
                      return <DropDownType items={items} isBtn={isBtn} />;
                    })}
                  </Menu>
                </Box>
              ) : (
                <a href={item.link} className={classes.navItem}>
                  {item.name}
                </a>
              );
            })}
          </Box>
        {
          ! deskTopView && <Box style={{ display: "flex", alignItems: "center" }}>
            <img
              className={classes.logoImg}
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              onClick={() => {
                window.location.href = `/${username ? `${username}` : ""}`;
              }}
            />
          </Box>
        }
           
        </div>
      </div>
      {showLogin && <LoginSignUpModal onClose={() => setShowLogin(false)} />}
    </>
  );
};

export default Component12;
